import json from './sprite.js';

export default {
    handle: 'ENG_SPT6-Chores_225002643',
    label: 'en_SPT6-Chores_225002643',
    json,
};
